const TableRecordNotFound = () => {
    return (
        <div className="listBoxproduct" style={{ gridTemplateColumns:"unset"  }}>
            <h5 style={{ textAlign:"center",marginBottom:"unset"}}>No Tours Found</h5>
        </div>
    )
}
export default TableRecordNotFound